import React from "react";
import { Button, Icon, Modal, Message, Segment, Label, Checkbox } from "semantic-ui-react";
import notificationSound1 from "../../../../assets/sounds/mixkit-correct-answer-tone-2870.wav";
import notificationSound2 from "../../../../assets/sounds/mixkit-atm-cash-machine-key-press-2841.wav";
import notificationSound3 from "../../../../assets/sounds/mixkit-gaming-lock-2848.wav";
import notificationSound4 from "../../../../assets/sounds/mixkit-software-interface-back-2575.wav";
import notificationSound5 from "../../../../assets/sounds/mixkit-retro-game-notification-212.wav";

const AudioNotificationModal = ({ session, setMyNotificationSound }) => {
	return (
		<Modal
			trigger={
				<Button>
					<Icon name="volume up" />
					Notification audio
				</Button>
			}
			header="Ma notification audio"
			content={
				<>
					<Message>Sélectionnez le son que vous souhaitez entendre lorsqu'une nouvelle demande d'aide est disponible.</Message>

					<Segment>
						{[notificationSound1, notificationSound2, notificationSound3, notificationSound4, notificationSound5].map((s, index) => (
							<Button as="div" labelPosition="left" key={`son-${index}`}>
								<Label
									as="a"
									onClick={() => {
										new Audio(s).play();
										setMyNotificationSound(s);
									}}
									basic
								>
									<Checkbox radio style={{ marginRight: "10px" }} checked={s === session.soundNotification} /> Son {index + 1}
								</Label>
								<Button
									onClick={() => {
										new Audio(s).play();
									}}
								>
									<Icon name="play" />
								</Button>
							</Button>
						))}
					</Segment>
				</>
			}
			actions={[{ key: "done", content: "OK", positive: true }]}
		/>
	);
};
export default AudioNotificationModal;
